<template>
	<v-card :elevation="1" class="background-2 round-card">
        <v-card-title class="pa-3">
			<p class="pl-2 pl-xl-3">{{ title }}</p>
	        <v-spacer></v-spacer>
			<v-tooltip top>
				<template v-slot:activator="{ on }">
					<v-btn v-on="on" @click="expand = !expand" icon>
						<v-icon>{{ expand ? 'expand_less' : 'expand_more' }}</v-icon>
					</v-btn>
				</template>                    
				<span>{{ expand ? 'Contrai' : 'Espandi' }}</span>
			</v-tooltip>			
        </v-card-title>       		
	    <v-divider></v-divider>

		<v-expand-transition>
			<v-data-table
				class="background-2"
				v-show="expand"
				:headers="filterHeader"
				:items="collection"
				item-key="id"
				:mobile-breakpoint="0"
				:footer-props="{
					'items-per-page-options': [10, 25, 50,  { text: 'Tutti', value: -1 }]
				}">
				<template slot="items" slot-scope="props">
					<tr @click="props.expanded = !props.expanded" class="cursor-pointer">
						<template v-for="(header, h) in filterHeader">

							<td v-if="header.value === 'number'" style="width: 40px" :key="h">
								{{ props.index +1 }}
							</td>
							<td v-else-if="header.type == 'currency'" :key="h">
								{{ props.item[header.value] | currency }}
							</td>	
							<td v-else :key="h">
								{{ props.item[header.value] }}
							</td>
						</template>
					</tr>
				</template>
				<template v-if="collection[props.index].description" slot="expand" slot-scope="props">
					<v-card text :key="props.index">
						<v-card-text pa-4 v-html="collection[props.index].description"></v-card-text>
					</v-card>
				</template>
				<template v-slot:footer.page-text="{ pageStart, pageStop }">
					Da {{ pageStart }} a {{ pageStop }} di {{ collection.length }}
				</template>
			</v-data-table>
		</v-expand-transition>
		<v-container class="py-3 px-3" v-if="totals && !totalsHidden">
			<totals-cards
				:totals-fields="computedTotalsFields"
				:data="computedTotalsData"
			></totals-cards>
		</v-container>
	</v-card>
</template>


<script>
	import TotalsCards from '@/components/common/TotalsCards'

    export default {
        name: 'trouble-products',
		components: {
			TotalsCards
		},
        props: {
            collection: Array,
            headers: Array,
			totals: Object,
			editModelId: Number,
			title: String,
			totalsFieldsConfig: {
				type: Array,
				default: null
			},
			totalsHidden: {
				type: Boolean,
				default: false
			}
        },
        data() {
            return {
                model: {},
				url: 'troubles/',
				expand: true
            }
        },

        computed: {
			computedTotalsFields() {
				return this.totalsFieldsConfig || []
			},

			computedTotalsData() {
				return {
					...this.totals,
					total_quantity: this.totalQuantity,
					total_missing_quantity: this.totalQuantityAuthorized,
					total_cost: this.totalCost
				}
			},

        	filterHeader() {
				return this.headers.filter(header => header.value != 'actions')
			},

        	totalQuantity() {
				return this.collection.reduce((acc, c) => acc + c.quantity, 0)
			},

        	totalQuantityAuthorized() {
				return this.collection.reduce((acc, c) => acc + c.missing_quantity, 0)
        	},

			// il costo arriva dal backend solo con la setting show_product_cost attiva,
			// come la card corrispondente (fieldDef total_cost); cost e' gia' il costo di riga
			totalCost() {
				return this.collection.reduce((acc, c) => acc + (c.cost || 0), 0)
			}
		},

		created() {
			if (this.$store.getters.checkSettings('compact_trouble_view')) {
				this.expand = false
			} else {
				this.expand = !this.$store.getters.checkSettings('compact_viewing')
			}
		}

    }
</script>